<template>
  <div class="outside_wrap">
    <uni-popup ref="hisPrescrip" type="bottom">
      <uni-card title="历史处方" :is-full="true">
        <div class="gridClass">
          <uni-list :border="false">
            <div
              v-for="(item, i) in prescripList"
              :key="i"
              class="list-item-wrap"
              @click="clickPreDetail(item, i)"
            >
              <!-- 消息中心-红点 -->
              <div class="dot">
                <!-- <message-center
                  :show="true"
                  message-type="10"
                  :message-id="item.visitID"
                  :business-id="item.id"
                /> -->
              </div>
              <div class="pre_wrap">
                <div class="prescripType">
                  <span style="margin-left: 0.341333rem">
                    {{ getKeyValueText('prescrip_type', item.prescripType) }}处方
                  </span>
                </div>
                <img
                  class="trapezoid"
                  src="@funcPuzzle/mini_doctor/trapezoid.png"
                />
                <div class="prescripState">
                  <span v-if="item.state != '4'">
                    {{
                      getKeyValueText('prescrip_state', item.state) +
                      ' / ' +
                      getKeyValueText('pay_state', item.payState)
                    }}
                  </span>
                </div>
              </div>
              <div class="prescrip-wrap">
                <div class="prescrip-msg">
                  <span>No.{{ item.prescripNum }}</span>
                </div>
                <div class="prescrip-msg">
                  <span>开方日期：{{ item.createTime }}</span>
                </div>
                <div class="prescrip-msg">
                  <span class="diagnose"> 诊断：{{ formatSymptomName(item.diagnosis) }} </span>
                </div>
                <div class="prescrip-msg drug">
                  <span>药品：</span>
                  <span :class="{ mdrug: ['4', '7'].includes(item.prescripType) }">
                    {{ item.prescripDrugsInfoList[0].drugName + ' ' }}
                    {{ item.prescripDrugsInfoList[0].drugSpec }}
                  </span>
                </div>
              </div>
            </div>
          </uni-list>
        </div>
        <div class="bottom">
          <div v-if="!['26281', '27971'].includes(this.hospitalID)">
            <div v-if="!isSubmitting" class="footer-box" @click="commitAllDraftsEvent">
              <span class="btn">提交全部草稿</span>
            </div>
            <button v-if="isSubmitting" type="default" loading="true" disabled="true">
              提交中
            </button>
          </div>

          <div
            :class="!['26281', '27971'].includes(this.hospitalID) ? 'footer-box' : 'long-box'"
            @click="createPrescrip"
          >
            <span class="btn">添加新处方</span>
          </div>
        </div>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-prescription
      ref="prescription"
      v-model:visible="showPrescription"
      :symptom-name="symptomName"
      :patient-phone="patientPhone"
      :seleted-index="seletedIndex"
      :visit-no="visitNo"
      :pre-length="preLength"
      :visitRecordType="visitRecordType"
    />
    <uni-popup ref="prescripTipPop">
      <div class="popup-wrap">
        <div class="content-wrap">
          <!-- "prescripType === '4' ? 'mdrug' : 'theSon'" -->
          <span :class="[stockError ? 'mdrug' : 'theSon', 'common']">
            {{ codeDesc }}
          </span>
        </div>
        <div class="have-know" @click="haveKnow">
          <span>我知道了</span>
        </div>
      </div>
    </uni-popup>
    <!-- 药品库存不足弹窗 -->
    <uni-popup ref="popupDialog" type="dialog">
      <uni-popup-dialog
        type="warn"
        mode="base"
        :content="tip"
        :stockLack="true"
        :before-close="true"
        :showConfirmButton="showConfirmButton"
        @close="closeDialog"
        @confirm="confirmDialog"
      />
    </uni-popup>
    <uni-popup ref="useDialog" type="dialog">
      <uni-popup-dialog
        :showTitle="false"
        mode="base"
        :content="useTip"
        :stockLack="true"
        :confirmText="'知道了'"
        :showConfirmButton="true"
        :showCancelButton="false"
        @confirm="confirmUseDialog"
      />
    </uni-popup>
  </div>
</template>
<script>
import { formatSymptomName, getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
// import MessageCenter from '@/subpackage/home/components/message-center/message-center'
import {
  aCheckDrugStock,
  batchDraftSaving,
  querySignStatus,
  getBusinessDicList
} from '@/views/funcPuzzle/utils/index.js'
import { mapState } from 'vuex'
import { debounce } from '@/utils/debounce.js'
import MsPrescription from '@/views/funcPuzzle/components/ms-prescription/ms-prescription.vue'

export default {
  components: {
    // MessageCenter,
    MsPrescription
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    prescripList: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    symptomName: {
      type: [Object, String],
      default: ''
    },
    patientPhone: {
      type: [Object, String],
      default: ''
    },
    visitNo: {
      type: [Object, String],
      default: ''
    },
    visitID: {
      type: String,
      default: ''
    },
    visitRecordType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showAddDrug: false,
      showPrescription: false,
      prescripItem: '',
      seletedIndex: '',
      codeDesc: '',
      errorMessage: '',
      toBeSubmitted: [],
      isSubmitting: false,
      showConfirmButton: false,
      tip: '',
      failDatas: [],
      sucDatas: [],
      signType: '',
      code: '',
      signState: {
        2: '成功',
        0: '失败',
        3: '失败',
        5: '失败',
        7: '失败',
        '-1': '失败'
      },
      signTipText: '',
      stockError: false,
      useTip: ''
    }
  },
  computed: {
    preLength: {
      get() {
        return this.prescripList.length
      },
      set() {}
    },
    ...mapState(['hospitalInfo']),
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$refs.hisPrescrip.open()
      } else {
        this.close()
      }
    },
    value(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    formatSymptomName,
    getKeyValueText,
    // 药品库存不足取消
    closeDialog() {
      uni.hideLoading()
      this.$refs.popupDialog.close()
      this.isSubmitting = false
      return false
    },
    confirmDialog() {
      this.closeDialog()
      this.draftSavingFunc()
    },
    haveKnow() {
      this.$refs.prescripTipPop.close()
    },
    close() {
      if (!this.$refs.hisPrescrip) {
        return false
      }
      this.$emit('update:visible', false)
      this.$refs.hisPrescrip.close()
    },
    open() {
      this.$refs.hisPrescrip.open()
    },
    // 触发提交全部草稿按钮
    commitAllDraftsEvent() {
      // state为-1 代表处方列表中 有“待提交”状态的处方
      const toBeSubmitted = this.prescripList.filter(item => {
        return item.state === '0'
      })
      this.toBeSubmitted = [...toBeSubmitted]

      // 待提交的数组长度为0 提示“暂无待提交处方”
      if (toBeSubmitted.length === 0) {
        uni.showToast({
          title: '暂无待提交处方',
          icon: 'none'
        })
      } else {
        // 当前有待提交处方时，需要有弹窗确认提示
        uni.showModal({
          title: '',
          content: `当前有${toBeSubmitted.length}个待提交处方，确认提交？`,
          success: res => {
            if (res.confirm) {
              this.isSubmitting = true
              // 点击确认 调用“待提交处方”接口
              this.commitAllDraftsFunc()
            } else if (res.cancel) {
              return false
            }
          }
        })
      }
    },
    // 批量提交 需要校验库存 还有签名
    commitAllDraftsFunc() {
      // 校验库存
      this.checkDrugStock()
    },
    checkDrugStock() {
      const drugList = this.toBeSubmitted.map(item => {
        return [...item.prescripDrugsInfoList]
      })

      // 将处方列表中的药品信息提取出来 连接在一起
      const flatArr = [].concat(...drugList)
      let arr = []
      flatArr.filter(item => {
        // drugID字段第一个字符为“7” 代表该处方是一人一方 需要做特殊处理
        const firstIndex = item.drugID.indexOf('7')
        if (firstIndex === 0) {
          const temp = JSON.parse(JSON.stringify(flatArr))
          // 一人一方药品 amount处以1000
          arr = temp.map(item => {
            return {
              drugId: item.drugID,
              drugName: item.drugName,
              drugType: item.drugType,
              amount: item.amount / 1000,
              warehouseID: item.warehouseID
            }
          })
        } else {
          // 非一人一方药品
          arr = flatArr.map(item => {
            return {
              drugId: item.drugID,
              drugName: item.drugName,
              drugType: item.drugType,
              amount: item.amount,
              warehouseID: item.warehouseID
            }
          })
        }
      })

      arr = arr.reduce((total, cur, index) => {
        const hasValue = total.findIndex(current => {
          return current.drugId === cur.drugId
        })
        hasValue === -1 && total.push(cur)
        hasValue !== -1 && (total[hasValue].amount = total[hasValue].amount + cur.amount)
        return total
      }, [])

      const params = { drugs: arr, flag: '1' }

      // 调用校验库存接口
      aCheckDrugStock(params).then(rs => {
        if (rs.DrugList && rs.DrugList[0]) {
          rs.DrugList = rs.DrugList.map((item, index) => {
            arr.filter(val => {
              // 库存不足 isLack设为true
              if (item.drugID === val.drugId && Number(val.amount) > Number(item.stockQuantity)) {
                rs.DrugList[index].isLack = true
                rs.DrugList[index].drugName = val.drugName
              }
            })
            return item
          })
        } else if ([-1, -2].includes(rs.code) && !rs.DrugList) {
          this.stockError = true
          this.isSubmitting = false
          this.codeDesc = rs.codeDesc || rs.msg
          // 失败弹窗提示
          this.prescripTipOpen()
          return false
        }
        let name = ''
        const array = []
        //提交的时候isOpen需要先设置成false，否则第一次库存不足会导致修改后库存足够的信息依旧无法通过检验
        this.isOpen = false
        for (let i = 0; i < rs.DrugList.length; i++) {
          if (rs.DrugList[i].isLack) {
            name = rs.DrugList[i].drugName
            array.push(`${name}药品库存不足，当前库存为${rs.DrugList[i].stockQuantity}`)
            this.isOpen = true
          }
        }

        this.tip = array.join(',')
        // 库存不足
        if (this.isOpen) {
          uni.hideLoading()
          this.getBusinessStore()
        } else {
          // 扁平化数组
          const flattenArr = drugList.reduce((acc, curr) => acc.concat(curr), [])

          // 过滤出院内药房的药品
          const hospitalDrugList = flattenArr.filter(item => {
            return item.warehouseID === '1001'
          })

          const reduceArr = this.reduceAmount(hospitalDrugList)

          // 判断当前开具的药品中 dailyConsumption是否有值 或者为0
          // const isHaveDailyConsumption = rs.DrugList.find(
          //   item => item.dailyConsumption || item.dailyConsumption == 0
          // )

          rs.DrugList = rs.DrugList.filter(item => {
            return item.dailyConsumption || item.dailyConsumption == 0
          })

          // dailyConsumption有值才进行提示
          if (rs.DrugList[0]) {
            this.issuablePopup(reduceArr, rs)
          } else {
            // 调用批量提交方法
            this.draftSavingFunc()
          }
        }
      })
    },
    reduceAmount(arr) {
      const groupByNameDrugID = arr.reduce((result, cur) => {
        const key = cur.drugID

        if (!result[key]) {
          result[key] = { ...cur, ...{ drugID: key, amount: 0 } }
        }
        result[key].amount += cur.amount
        return result
      }, {})
      const res = Object.values(groupByNameDrugID)
      return res
    },
    issuablePopup(drugList, rs) {
      const array = []

      // 筛选出dailyConsumption不为空的
      drugList.forEach(item => {
        rs.DrugList.some(val => {
          // 查询出相同drugID的药品 并给drugList中药品的useConsumption和dailyConsumption赋值
          // 这个时候查到的这两个值是最新的
          if (item.drugID === val.drugID) {
            item.useConsumption = val.useConsumption
            item.dailyConsumption = val.dailyConsumption
          }
        })
      })
      drugList = drugList.filter(item => {
        return item.dailyConsumption || item.dailyConsumption == 0
      })

      const have = drugList.some(
        item => item.dailyConsumption - Number(item.useConsumption) < item.amount
      )

      drugList.forEach(item => {
        // 如果药品发药数量超过了可开具数量
        if (item.dailyConsumption - Number(item.useConsumption) < item.amount) {
          const unit = this.switchFunc(item)

          // 将对多个药品的提示放到数组中
          array.push(
            `${item.commonName || item.drugName} 单日消耗总量限制为 【${
              item.dailyConsumption
            }】${unit}，当前可开具【${
              item.dailyConsumption > item.useConsumption
                ? item.dailyConsumption - item.useConsumption
                : 0
            }】${unit}，您开具的【${item.amount}】${unit}已超量。`
          )

          uni.hideLoading()
          // 校验药品发药数量是否超过可开具数量弹窗提示
          this.$refs.useDialog.open()
          this.isSubmitting = false

          return false
        }
      })
      if (!have) {
        //  草稿都符合需求时 调用批量提交方法
        this.draftSavingFunc()
      }

      this.useTip = array.join('\n')
    },
    confirmUseDialog() {
      this.$refs.useDialog.close()
      return false
    },
    switchFunc(item) {
      // 中成药、西药、蒙药 用的是packageUnit
      const chinesePatentVals = ['1', '2', '8']
      // 中草药、小包装、中药颗粒 用的是measureUnit
      const chineseHerbalVals = ['4', '5', '6']
      switch (item.drugType) {
        case chinesePatentVals[0]:
        case chinesePatentVals[1]:
        case chinesePatentVals[2]:
          return getKeyValueText('package_unit', item.packageUnit)
        // 蒙药（蒙）用的是packageUnit
        case '3':
          return getKeyValueText('package_unit_meng', item.packageUnit)
        case chineseHerbalVals[0]:
        case chineseHerbalVals[1]:
        case chineseHerbalVals[2]:
          return getKeyValueText('measure_unit', item.measureUnit)
      }
    },
    getBusinessStore() {
      getBusinessDicList({
        pageNum: 1,
        pageSize: 1,
        tableName: 'enabled_precrip_on_not_enogh_stock',
        code: ''
      }).then(rs => {
        // 不展示确定按钮
        const cannotCreate = JSON.parse(
          rs.DoctorServicePackageList[0].value
        ).enablePrecripHospital.find(item => item.hospitalID === this.hospitalInfo.hospitalID)

        this.showConfirmButton = cannotCreate ? false : true
        this.$refs.popupDialog.open()
      })
    },
    // 调用批量提交方法
    draftSavingFunc() {
      // 处理prescripNum参数 array形式
      const prescripNums = this.toBeSubmitted.map(item => {
        return item.prescripNum
      })

      // 忽略库存校验参数 传true 库存校验全由前端来处理
      // 忽略合理用药参数 中医院传false 其他医院传true
      const submitParams =
        this.hospitalID === '27216'
          ? {
              hospitalID: this.hospitalID,
              prescripNums,
              ignoreDrugStockValidation: true,
              ignoreRationalDrugUseInspection: false
            }
          : {
              hospitalID: this.hospitalID,
              prescripNums,
              ignoreDrugStockValidation: true,
              ignoreRationalDrugUseInspection: true
            }
      // 批量提交方法
      batchDraftSaving(submitParams)
        .then(res => {
          // code为-1 全部失败 弹出全部失败的codeDesc提示 不需要去签名 直接return
          if (res.code === -1) {
            this.codeDesc = res.codeDesc
            // 失败弹窗提示
            this.prescripTipOpen()
            this.isSubmitting = false
            return
          }
          // 肯定有成功的
          else {
            this.code = res.code
            this.signType = res.data.signType
            // 批量提交处方全部成功 并且不需要去签名 则提示提交成功
            if (res.code === 0 && this.signType && this.signType !== 3) {
              uni.showToast({
                title: `提交成功`,
                icon: 'none',
                duration: 2500
              })
            }
            // code为1000 代表其中有失败的 需要弹出成功和失败的提示
            if (res.code === 1000) {
              this.failDatas = res.data.failDatas
              // 把部分失败的提示准备好
              this.errorMessage = `您成功提交${res.data.sucDatas.length}个处方，${res.data.failDatas.length}个处方提交失败`
            }
            // 批量提交处方后 刷新历史处方列表
            this.$parent.getHistoryPre('处方', this.visitID)
            this.isSubmitting = false

            // 如果需要签名 signType 1无需签名，2院内 3 e签宝 4免签
            // e签宝
            if (res.data.signType === 3) {
              this.sucDatas = res.data.sucDatas
              this.toEsign(res.data)
              return
              // 1和4是一种情况 2是医大四医院和肿瘤的情况 但是他俩不需要批量提交
            }
            // 部分成功 部分失败的提示 并且不需要签名的情况下
            else if (res.code === 1000) {
              this.handleSignErrorMsg()
            }
          }
        })
        .catch(error => {
          // this.codeDesc = '保存处方请求失败，请稍后重试'
          // this.prescripTipOpen()
        })
    },
    // E签宝
    toEsign(res) {
      const _this = this
      const prescripNums = _this.sucDatas
        .map(item => {
          return item.prescripNum
        })
        .join(',')
      wx.navigateToMiniProgram({
        appId: 'wx1cf2708c2de46337', // 上链公证签小程序APPID
        path: '/pages/index/index', // 上链公证签页面地址
        extraData: {
          requestObj: {
            // 必填，入参
            flowId: res.flowId, // 必填，签署流程id
            accountId: res.accountId, // 签署必填，账号id
            type: 'SIGN', // 非必填，业务类型：签署 SIGN（默认）
            env: 'prod' // 非必填，对接环境：线上 prod(默认）, 模拟 sml(用于对接调试阶段）
          }
        },
        success(ress) {
          _this.toObtainState({
            prescripNum: prescripNums, // 处方编号
            doctorId: res.doctorId
          })
        },
        fail(resf) {
          // 根据自身需要
          uni.showToast({
            title: '调用e签宝小程序失败，请重试',
            icon: 'none'
          })
        }
        // complete(resc) {
        //   // 根据自身需要
        // }
      })
    },
    // 轮询签名状态
    async toObtainState(querydata) {
      uni.showModal({
        title: '提示',
        content: '签名是否完成？',
        cancelText: '取消',
        confirmText: '已签名',
        success: res => {
          if (res.confirm) {
            debounce(() => {
              this.checkSignResult(querydata)
            }, 1500)
          } else {
            uni.showToast({
              title: '用户已取消',
              duration: 1500
            })
          }
        }
      })
    },
    checkSignResult(querydata) {
      const params = Object.assign(
        {
          hospitalID: this.hospitalID,
          businessType: 1 // 1 开方，2审核，3发药
        },
        querydata
      )
      uni.showLoading({
        title: '结果查询中',
        icon: 'none'
      })
      this.newFunc(params, 0)
      // try {
      //   let times = 0
      //   let flag = false
      //   // this.timer = setInterval(async () => {
      //     if (flag) {
      //       clearInterval(this.timer)
      //       return
      //     }

      //     // // 签名超时
      //     // if (times === 15) {
      //     //   clearInterval(this.timer)
      //     //   this.codeDesc = '提交失败！'
      //     //   // 失败弹窗提示
      //     //   this.prescripTipOpen()
      //     //   // 批量提交处方后 刷新历史处方列表
      //     //   this.$parent.getHistoryPre('处方', this.visitID)
      //     //   return
      //     // } else {
      //     //   times++
      //     // }
      //   // }, 1500)
      // } catch (error) {
      //   // 添加trycatch，防止出现异常时，loading无法关闭
      //   clearInterval(this.timer)
      //   uni.hideLoading()
      // }
    },
    newFunc(params, timers) {
      querySignStatus(params).then(res => {
        uni.hideLoading()

        // res.code 1签署中，2签署成功，5过期，7拒签，-1异常
        if (res.code === 1) {
          setTimeout(() => {
            timers++
            if (timers === 10) {
              this.codeDesc = '提交失败！'
              // 失败弹窗提示
              this.prescripTipOpen()
              // 批量提交处方后 刷新历史处方列表
              this.$parent.getHistoryPre('处方', this.visitID)
              return
            }
            this.newFunc(params, timers)
          }, 1000)
          return
        }
        // 当值不为1时，就没在签署状态，清除计时，关闭loading

        // res.code 不为1，那就该结束轮询，状态为失败或成功，并不在等待状态

        // 处方全部提交成功
        if (this.code === 0) {
          // 签名成功
          if (res.code === 2) {
            uni.showToast({
              title: `提交成功`,
              icon: 'none',
              duration: 2500
            })
            // 批量提交处方后 刷新历史处方列表
            this.$parent.getHistoryPre('处方', this.visitID)
            return
          }
          // 签名失败
          else {
            this.codeDesc = this.signTip(res)
            // 失败弹窗提示
            this.prescripTipOpen()
            // 批量提交处方后 刷新历史处方列表
            this.$parent.getHistoryPre('处方', this.visitID)
            return
          }
        }

        // 批量提交 部分成功 部分失败
        if (this.failDatas && this.failDatas[0] && this.code === 1000) {
          this.errorMessage = `您成功提交${this.sucDatas.length}个处方，${this.failDatas.length}个处方提交失败`

          this.signTipText = this.signTip(res)

          // 签名失败的提示
          this.handleSignErrorMsg()
          // 批量提交处方后 刷新历史处方列表
          this.$parent.getHistoryPre('处方', this.visitID)
          return
        }
        // 批量提交处方后 刷新历史处方列表
        this.$parent.getHistoryPre('处方', this.visitID)
      })
    },
    // 签名返回的提示
    signTip(res) {
      const signPrescripNums = this.sucDatas
        .map(item => {
          return `NO.${item.prescripNum}签名${this.signState[Number(res.code)]}`
        })
        .join(',')
      const tips = `${signPrescripNums}
      ${res.codeDesc}`
      return tips
    },
    /*
      整体批量提交有失败的 提示
    */
    handleSignErrorMsg() {
      const preErrorMsg = this.failDatas
        .map(item => {
          return `NO.${item.prescripNum}${item.errorMessage}`
        })
        .join(',')
      const interErrorMsg = `${preErrorMsg}`
      this.codeDesc = `${this.errorMessage}
      ${this.signTipText}
      ${interErrorMsg}`

      // 失败弹窗提示
      this.prescripTipOpen()
      // 批量提交处方后 刷新历史处方列表
      this.$parent.getHistoryPre('处方', this.visitID)
      return
    },
    prescripTipOpen() {
      this.$refs.prescripTipPop.open()
    },
    createPrescrip() {
      this.$bus.emit('showSelectPre')
      this.$bus.emit('createNewPre', this.preLength)
      this.close()
    },
    clickPreDetail(item, i) {
      // this.$emit('clickPreDetail', item)
      // this.$bus.emit('clickHistory', item)

      this.preDetail = item
      this.sysName = item.symptomName
      this.isHis = true
      this.seletedIndex = i
      this.$refs.hisPrescrip.close()
      // this.$refs.prescription.open()
      this.$bus.emit('prescripDetail', {
        preItem: item
      })
    }
  },
  mounted() {
    this.$bus.on('backToHis', val => {
      if (val) {
        this.$refs.hisPrescrip.open()
      }
    })
  },
  unmounted() {
    this.$bus.off('createNewPre')
    this.$bus.off('showSelectPre')
    this.$bus.off('clickHistory')
  }
}
</script>

<style scoped></style>
<style lang="scss" scoped>
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  padding: 0.682667rem;
  z-index: 1100;
  .list-item-wrap {
    position: relative;
    .dot {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
    }
  }
  .pre_wrap {
    width: 14.634667rem;
    height: 1.365333rem;
    display: flex;
    // border: .021333rem solid #ececec;
    border-bottom: none;
    // background: url(~@funcPuzzle/mini_doctor/history_long_bg.png)
    //   no-repeat;
    background-size: cover;
    border-radius: 0.085333rem;
    .prescripType {
      width: auto;
      height: 1.365333rem;
      color: #fff;
      font-size: 0.682667rem;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 1.365333rem;
      background-color: #0089ff;
    }
    .trapezoid {
      width: 0.64rem;
      height: 1.365333rem;
      background-color: #eaf5ff;
    }
    .prescripState {
      flex: 1;
      height: 1.365333rem;
      font-size: 0.682667rem;
      font-weight: 400;
      color: #888;
      text-align: end;
      padding-right: 0.426667rem;
      line-height: 1.365333rem;
      background-color: #eaf5ff;
    }
  }
  .prescrip-wrap {
    width: 14.634667rem;
    height: auto;
    padding: 0.682667rem 0.533333rem;
    border: 0.021333rem solid #ececec;
    margin-bottom: 0.682667rem;
    box-sizing: border-box;
    border-top: none;
    border-radius: 0 0 0.085333rem 0.085333rem;
    .prescrip-msg,
    .drug {
      display: flex;
      margin-bottom: 0.768rem;
      text {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222222;
        line-height: 0.64rem;
      }
      .diagnose {
        line-height: 0.853333rem;
        font-family: Menksoft Budun;
      }
    }
    .drug {
      margin-bottom: 0;
    }
  }
  .patientName {
    font-size: 0.725333rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #222222;
  }
}
.bottom {
  display: flex;
  justify-content: space-between;
  height: 4.138667rem;
  padding: 0.384rem 0.682667rem;
  box-sizing: border-box;
  button::after {
    border: 0; // 或者 border: none;
  }
  button {
    text-align: center;
    width: 6.976rem;
    height: 1.877333rem;
    background: #ffffff;
    border-radius: 0.938667rem;
    border: 0.021333rem solid #0089ff;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    font-weight: 500;
    color: #0089ff;
  }
  .footer-box,
  .long-box {
    text-align: center;
    width: 6.976rem;
    height: 1.877333rem;
    background: #ffffff;
    border-radius: 0.938667rem;
    border: 0.021333rem solid #0089ff;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    font-weight: 500;
    .btn {
      color: #0089ff;
    }
  }
  .long-box {
    width: 14.634667rem;
  }
}
.popup-wrap {
  width: 10.666667rem;
  min-height: 5.546667rem;
  border-radius: 0.341333rem;
  padding: 0.64rem 0.64rem 2.773333rem 0.64rem;
  background-color: #fff;
  font-size: 0.512rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 0.810667rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  .content-wrap {
    width: 9.386667rem;
    color: #222222;
    font-size: 0.64rem;
    white-space: normal;
    word-break: break-all;
    overflow-y: scroll;
    max-height: 17.066667rem;
    .common {
      word-wrap: break-word;
    }
  }
  .have-know {
    width: 6.4rem;
    height: 1.706667rem;
    text-align: center;
    line-height: 1.706667rem;
    color: #0089ff;
    border-radius: 0.853333rem;
    align-self: center;
    border: 0.021333rem solid #0089ff;
    position: absolute;
    left: 2.133333rem;
    bottom: 0.768rem;
  }
  .protocol {
    width: 100%;
    height: 1.450667rem;
    display: flex;
    align-items: center;
    .protocol-text {
      font-size: 0.512rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888;
    }
  }
}
</style>
